const path = 'redux/widget';
export const UPDATE_WIDGET_STATUS = `${path}/UPDATE_WIDGET_STATUS`;

